import { Component } from '@angular/core';
import { NavController,AlertController} from 'ionic-angular';
import { StorageService } from '../../../providers/service/storageservice';
import { AppState } from '../../../app/app.global';
@Component({
  selector: 'skin-page',
  templateUrl: 'skin.html'
})
export class SkinPage {
  //colorTheme:string =  StorageService.getObj('colorTheme');
  constructor (public navCtrl: NavController,public alertCtrl: AlertController,public global: AppState  ) {

  }
	confirmColor(color:any,colorName:any){
		let alert = this.alertCtrl.create({
	    message: '确认更换主题为'+colorName+'?',
	    buttons: [
	      {
	        text: '取消',
	        role: 'cancel',
	      },
	      {
	        text: '确认',
	        handler: () => {
           // config.set('', 'primary' , color);
            StorageService.setObj('colorTheme',color);
            //this.colorTheme = color;
            this.global.setTheme( color);
          }
	      }
	    ]
	  });
	  alert.present();
	}

}



// WEBPACK FOOTER //
// ./src/pages/about/skin/skin.ts